import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1875686809790415';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export const MetaPixel = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch {}
      return;
    }
    // Manual, guarded Meta Pixel install (replaces the standard snippet's
    // `t.parentNode.insertBefore(...)` which crashes when no <script> tag exists).
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    try {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      (document.head || document.documentElement).appendChild(script);
    } catch (e) {
      // Swallow — pixel failure should never break the page.
      return;
    }
    try {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch {}
    // Noscript fallback pixel (image beacon)
    try {
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    } catch {}
  }, []);
  return null;
};